import React, { memo, useEffect, useState } from 'react';
import PanelBossNote from './PanelBossNote';
import BossNote from 'src/interfaces/api/BossNote';
import { Button, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';
import useAuth from 'src/hooks/api/useAuth';

const PanelBossNoteContainer = () => {
  const [bossNotes, setBossNotes] = useState<BossNote[]>([]);
  const [loading, setLoading] = useState(true);
  const { fetch } = useAuth();

  useEffect(() => {
    fetch('/api/bossNote/{bossNotes{id, title, text, position, type, color, width, createdAt}}', {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'GET',
    })
      .then((resp) => {
        setLoading(false);
        return resp.json();
      })
      .then((data) => {
        if (data['data']['bossNotes']) {
          setBossNotes(data['data']['bossNotes']);
        }
      })
      .catch(() => {
        setLoading(false);
        console.log('erreur fetch BossNote entity');
      });
  }, []);

  if (loading) {
    return <div>Chargement ...</div>;
  }

  if (bossNotes.length <= 0) {
    return (
      <div style={{ textAlign: 'center' }}>
        <Typography variant='h5'>Bienvenue sur Scaleed !</Typography>
        <Typography>Il n'y a aucune actualité pour le moment</Typography>
        <Button
          style={{ color: 'white', marginTop: 30 }}
          variant='contained'
          color='primary'
          size='small'
          component={Link}
          to='/dashboard'
        >
          Aller au dashboard
        </Button>
      </div>
    );
  }

  return <PanelBossNote bossNotes={bossNotes} />;
};

export default memo(PanelBossNoteContainer);
